import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sidebar } from "../components/Sidebar";

export function TeamLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const closeNav = () => setMobileNavOpen(false);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Static sidebar on lg+; hidden below where the drawer takes over. */}
      <div className="hidden lg:flex">
        <Sidebar />
      </div>

      {/* Mobile slide-in drawer + backdrop (below lg only). */}
      {mobileNavOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <button
            type="button"
            aria-label="Close navigation"
            onClick={closeNav}
            className="absolute inset-0 h-full w-full cursor-default bg-black/50"
          />
          <div className="absolute inset-y-0 left-0 shadow-xl">
            <Sidebar onNavigate={closeNav} onClose={closeNav} />
          </div>
        </div>
      )}

      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Mobile top bar with hamburger (below lg only). */}
        <header className="flex h-14 shrink-0 items-center gap-3 border-b border-brand-border bg-brand-bg px-4 lg:hidden">
          <button
            type="button"
            onClick={() => setMobileNavOpen(true)}
            aria-label="Open navigation"
            aria-expanded={mobileNavOpen}
            className="-ml-2 rounded-md p-2 text-brand-muted hover:bg-brand-surface hover:text-brand-text"
          >
            <Menu className="h-5 w-5" aria-hidden="true" />
          </button>
          <span className="text-base font-semibold tracking-wide text-brand-text">
            Payment Products
          </span>
        </header>

        <main className="app-bg flex-1 overflow-y-auto">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 sm:py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
